module.exports = __webpack_public_path__ + "img/meiwa_logo_white.894a573e.png";